import api from "./api";
import axios from "axios";

/**
 * Fetch the dropdown list of eligible RNs.
 * GET /api/v1/scheduling/rns
 */
export const fetchEligibleRns = async () => {
  try {
    const response = await api.get("/api/v1/scheduling/rns", {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });
    return response.data;
  } catch (e) {
    throw new Error(e.response?.data?.message || "Failed to fetch eligible RNs");
  }
};

/**
 * Fetch programs where the member's DispositionStatus is ENROLLED and isCareGuidePlus == true.
 * GET /api/v1/scheduling/members/{memberId}/programs
 */
export const fetchMemberCgPlusPrograms = async (memberId) => {
  try {
    const response = await api.get(`/api/v1/scheduling/members/${memberId}/programs`, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });
    return response.data;
  } catch (e) {
    throw new Error(e.response?.data?.message || "Failed to fetch enrolled CG+ programs");
  }
};

/**
 * Book an RN visit appointment.
 * POST /api/v1/scheduling/book
 */
export const bookAppointment = async (payload) => {
  try {
    const response = await api.post("/api/v1/scheduling/book", payload, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });
    return response.data;
  } catch (e) {
    throw new Error(e.response?.data?.message || "Failed to book appointment");
  }
};

/**
 * Cancel/Delete an RN visit appointment.
 * DELETE /oauth/auth/calendar/delete
 */
export const deleteAppointment = async (payload) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.delete(
      `${(process.env.REACT_APP_BASE_URL || "").trim()}/oauth/auth/calendar/delete`,
      {
        data: payload,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (e) {
    throw new Error(e.response?.data?.message || "Failed to cancel appointment");
  }
};

/**
 * Reschedule an RN visit appointment.
 * POST /oauth/auth/calendar/reschedule
 */
export const rescheduleAppointment = async (payload) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${(process.env.REACT_APP_BASE_URL || "").trim()}/oauth/auth/calendar/reschedule`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (e) {
    throw new Error(e.response?.data?.message || "Failed to reschedule appointment");
  }
};

/**
 * Add an event to the calendar.
 * POST /oauth/auth/calendar/add
 */
export const addCalendarEvent = async (payload) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${(process.env.REACT_APP_BASE_URL || "").trim()}/oauth/auth/calendar/add`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (e) {
    throw new Error(e.response?.data?.message || "Failed to add calendar event");
  }
};

